/**
 * Cross-page navigation without prop threading. Pages dispatch a request;
 * the app shell listens and switches tabs through its normal access checks.
 *
 *   navigateTo('adminDocuments', { documentsTab: 'amendments' })
 *   navigateTo('factFind', { section: 'riskProfile' })   // opens the page scrolled to that section
 */
export const APP_NAVIGATE_EVENT = 'advicelink:navigate';

let pendingDocumentsTab = null;
let pendingGuideLink = null;

export function navigateTo(tab, extra = {}) {
  if (extra.documentsTab) pendingDocumentsTab = extra.documentsTab;
  if (tab === 'guides' && (extra.videoId || extra.videoWorkflow)) {
    pendingGuideLink = { videoId: extra.videoId || null, workflowId: extra.videoWorkflow || null, chapter: extra.chapter || null };
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(APP_NAVIGATE_EVENT, { detail: { tab, ...extra } }));
  }
}

/** Read and clear the tab the Documents page should open on (set by navigateTo). */
export function consumePendingDocumentsTab() {
  const tab = pendingDocumentsTab;
  pendingDocumentsTab = null;
  return tab;
}

/**
 * The video (or workflow section) the Guides page should open, set by
 * navigateTo('guides', { videoId | videoWorkflow }); a `chapter` with the
 * videoId starts a film there. Peeking leaves it in place (safe in a state
 * initializer, which React runs twice in development); the page clears it once
 * mounted.
 */
export function peekPendingGuideLink() {
  return pendingGuideLink || { videoId: null, workflowId: null, chapter: null };
}

export function clearPendingGuideLink() {
  pendingGuideLink = null;
}
